
import { useState, useEffect } from 'react';

interface ConsoleMessage {
  type: string;
  message: string;
  timestamp: Date;
}

export const useConsoleInterceptor = (isEnabled: boolean) => {
  const [consoleMessages, setConsoleMessages] = useState<Array<ConsoleMessage>>([]);
  
  useEffect(() => {
    if (!isEnabled) return;
    
    // Store original console methods
    const originalConsole = {
      log: console.log,
      warn: console.warn,
      error: console.error,
      info: console.info
    };
    
    const interceptConsole = () => {
      console.log = (...args) => {
        setConsoleMessages(prev => [...prev.slice(-50), {
          type: 'log',
          message: args.map(arg => typeof arg === 'object' ? JSON.stringify(arg) : String(arg)).join(' '),
          timestamp: new Date()
        }]);
        originalConsole.log(...args);
      };
      
      console.warn = (...args) => {
        setConsoleMessages(prev => [...prev.slice(-50), {
          type: 'warn',
          message: args.map(arg => typeof arg === 'object' ? JSON.stringify(arg) : String(arg)).join(' '),
          timestamp: new Date()
        }]);
        originalConsole.warn(...args);
      };
      
      console.error = (...args) => {
        setConsoleMessages(prev => [...prev.slice(-50), {
          type: 'error',
          message: args.map(arg => typeof arg === 'object' ? JSON.stringify(arg) : String(arg)).join(' '),
          timestamp: new Date()
        }]);
        originalConsole.error(...args);
      };
      
      console.info = (...args) => {
        setConsoleMessages(prev => [...prev.slice(-50), {
          type: 'info',
          message: args.map(arg => typeof arg === 'object' ? JSON.stringify(arg) : String(arg)).join(' '),
          timestamp: new Date()
        }]);
        originalConsole.info(...args);
      };
    };
    
    // Only intercept console when enabled
    if (isEnabled) {
      interceptConsole();
    }
    
    return () => {
      // Restore original console methods
      if (isEnabled) {
        console.log = originalConsole.log;
        console.warn = originalConsole.warn;
        console.error = originalConsole.error;
        console.info = originalConsole.info;
      }
    };
  }, [isEnabled]);
  
  return { consoleMessages, setConsoleMessages };
};
